module.exports = __webpack_public_path__ + "static/img/KMP869-395-93_A.e3676d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/KMP869-395-93_A.jpg
// module id = o3Ey
// module chunks = 0